import { isInteger } from 'lodash';
var IntegerValueValidation = /** @class */ (function () {
    function IntegerValueValidation() {
    }
    IntegerValueValidation.validate = function (control) {
        var number = Number(control.value);
        if (!control.value || isInteger(number) || control.hasError('min')) {
            return null;
        }
        return {
            integer: true
        };
    };
    return IntegerValueValidation;
}());
export { IntegerValueValidation };
